/**
 * Image with text video logic
 */

const initVideoToggle = () => {
    const videoContainers = document.querySelectorAll('.la-video');

    videoContainers.forEach(container => {
        const video = container.querySelector('.la-video-element');
        if (!video) return;

        container.addEventListener('click', function () {
            if (video.paused) {
                video.play();
                container.classList.add('is-playing');
            } else {
                video.pause();
                container.classList.remove('is-playing');
            }
        });

        video.addEventListener('ended', function () {
            container.classList.remove('is-playing');
            video.currentTime = 0; // Reset to beginning when finished
        });

        // Handle cases where the video might be paused/played by browser or other scripts
        video.addEventListener('play', () => container.classList.add('is-playing'));
        video.addEventListener('pause', () => container.classList.remove('is-playing'));
    });
};

document.addEventListener('DOMContentLoaded', initVideoToggle);

// If Shopify's section load happens after DOMContentLoaded (Theme Editor)
if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initVideoToggle);
}
